import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  "data-segment": 1,
  class: "pi pi-ellipsis-v"
}, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "sub-table-container" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "sub-table-heading" }, "Список департаментов", -1)

import { ref, computed } from "vue";
import { useRouter } from "vue-router";

import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Menu from "primevue/menu";
import UserCustomHistoryDialog from "@/widgets/dialogs/UserCustomHistoryDialog.vue";
import DeleteConfirmDialog from "@/shared/dialogs/DeleteConfirmDialog.vue";

import { convertDateFromUTC } from "@/services/utils/DateParser";
import { getUserName } from "@/services/utils/Names";
import {
  useOrganizationsStore,
  Department,
} from "@/store/dictionaries/organizations";
import {
  getEntitiesByOrganization,
  getHistories,
} from "@/services/dictionaries/organizations";
import { rootGetters } from "@/main";
import { useHistoryStore } from "@/store/history/history";
import { useAuthStore } from "@/store/auth/login";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationsTable',
  props: {
    organizations: {},
    isActiveFirst: { type: Boolean },
    isLoading: { type: Boolean },
    rowsCount: {}
  },
  emits: ["sortTable", "updateTable"],
  setup(__props: any, { emit: __emit }) {


const emits = __emit;
const router = useRouter();
const store = useOrganizationsStore();
const historyStore = useHistoryStore();
const authStore = useAuthStore();

let modifiedId = ref(0);
let modifiedOrg = ref<any>(null);
const confirmVisibleDelete = ref(false);
const confirmVisibleHistory = ref(false);
const blockedButtonDelete = ref(false);
const menu = ref();
const expandedRows = ref({});
const historyItems = ref<object[]>([]);
const items = ref([
  {
    label: "История действий",
    icon: "pi pi-history",
    checkDenied: true,
    archive: "both",
    command: () => {
      if (modifiedOrg.value) {
        const entities = getEntitiesByOrganization(modifiedOrg.value);

        historyStore.fetchAllHistoriesByEntity(entities).then((resp) => {
          historyItems.value = getHistories(resp);
        });
      }
      confirmVisibleHistory.value = true;
    },
  },
  {
    label: "Редактировать",
    icon: "pi pi-pencil",
    archive: "no_archive",
    command: () => {
      router.push({ name: "organization", params: { id: modifiedId.value } });
    },
  },
  {
    label: "Удалить",
    icon: "pi pi-trash",
    archive: "both",
    command: () => {
      confirmVisibleDelete.value = true;
    },
  },
]);

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(["history:edit"], ["history:read"]);
});

const filteredItems = computed(() => {
  return items.value.filter((item) => !(item.checkDenied && isDenied.value));
});

const departmentsArray = (departments: Department[]) => {
  return departments
    .map((department) =>
      (department.roles || []).map((role) => ({
        departmentName: department.name,
        roleName: role.name,
        ctime: role.ctime,
        mtime: role.mtime,
      })),
    )
    .flat();
};

const toggle = (elem: any, event: any) => {
  modifiedId.value = elem.id;
  modifiedOrg.value = elem;
  menu.value.toggle(event);
};

const sortTable = (event: any) => {
  let orderField = "";
  if (event.sortField)
    orderField = event.sortOrder > 0 ? event.sortField : `-${event.sortField}`;
  emits("sortTable", orderField);
};

const deleteOrganization = () => {
  blockedButtonDelete.value = true;
  store
    .deleteOrganization(modifiedId.value)
    .finally(() => {
      emits("updateTable");
      blockedButtonDelete.value = false;
      confirmVisibleDelete.value = false;
    })
    .catch((err) => {
      if (err.response && err.response.status == 400)
        rootGetters.toast.show("warn", "Ошибка", err.response.data.detail);
    });
};

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(DataTable), {
      value: _ctx.organizations,
      expandedRows: expandedRows.value,
      "onUpdate:expandedRows": _cache[0] || (_cache[0] = ($event: any) => ((expandedRows).value = $event)),
      class: _normalizeClass([[
      _ctx.organizations && _ctx.organizations.length == 0 ? 'empty-table' : '',
      _ctx.isActiveFirst ? 'active-first' : '',
    ], "scroll-table-y main-table scrollbar-custom"]),
      stripedRows: "",
      onSort: sortTable,
      removableSort: "",
      scrollable: "",
      loading: _ctx.isLoading,
      dataKey: "id",
      columnResizeMode: "expand"
    }, {
      expansion: _withCtx((slotProps) => [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_unref(DataTable), {
            value: departmentsArray(slotProps.data.departments),
            class: "sub-table"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Column), {
                field: "departmentName",
                header: "Наименование департамента"
              }),
              _createVNode(_unref(Column), {
                field: "roleName",
                header: "Должность"
              }),
              _createVNode(_unref(Column), {
                field: "ctime",
                header: "Дата создания",
                sortable: "",
                style: {"min-width":"153px"}
              }, {
                body: _withCtx((slotPropsRole) => [
                  _createTextVNode(_toDisplayString(_unref(convertDateFromUTC)(slotPropsRole.data.ctime)), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(Column), {
                field: "mtime",
                header: "Дата обновления",
                sortable: "",
                style: {"min-width":"173px","max-width":"173px"}
              }, {
                body: _withCtx((slotPropsRole) => [
                  _createTextVNode(_toDisplayString(_unref(convertDateFromUTC)(slotPropsRole.data.mtime)), 1)
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1032, ["value"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(Column), {
          expander: "",
          style: {"min-width":"52px","max-width":"52px"}
        }),
        _createVNode(_unref(Column), {
          field: "number",
          header: "№",
          style: {"min-width":"44px"}
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_ctx.rowsCount + slotProps.index + 1), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "name",
          header: "Название организации",
          sortable: "",
          style: {"min-width":"120px"}
        }, {
          body: _withCtx((slotProps) => [
            _createVNode(_component_RouterLink, {
              to: { name: 'organization', params: { id: slotProps.data.id } }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(slotProps.data.name), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "description",
          header: "Описание"
        }),
        _createVNode(_unref(Column), {
          field: "is_inhouse",
          header: "Тип организации"
        }, {
          body: _withCtx((slotProps) => [
            (slotProps.data.is_inhouse)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, " Внутренняя "))
              : (_openBlock(), _createElementBlock("span", _hoisted_2, "Внешняя"))
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "tenant",
          header: "Tenant"
        }),
        _createVNode(_unref(Column), {
          field: "is_demo",
          header: "Демо-организация"
        }, {
          body: _withCtx((slotProps) => [
            (slotProps.data.is_demo)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Да"))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, "Нет"))
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "cuser__lname",
          header: "Пользователь",
          sortable: "",
          style: {"max-width":"150px"}
        }, {
          body: _withCtx((slotProps) => [
            (slotProps.data.cuser)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(getUserName)(slotProps.data.cuser)), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, "-"))
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "ctime",
          header: "Дата создания",
          sortable: "",
          style: {"min-width":"153px"}
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_unref(convertDateFromUTC)(slotProps.data.ctime)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "mtime",
          header: "Дата обновления",
          sortable: "",
          style: {"min-width":"173px","max-width":"173px"}
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_unref(convertDateFromUTC)(slotProps.data.mtime)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          frozen: "",
          alignFrozen: "right"
        }, {
          body: _withCtx((slotProps) => [
            _createElementVNode("div", {
              onClick: (event) => toggle(slotProps.data, event),
              "aria-haspopup": "true",
              "aria-controls": "overlay_menu",
              class: "button-menu"
            }, _hoisted_9, 8, _hoisted_7)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "expandedRows", "class", "loading"]),
    _createVNode(_unref(Menu), {
      ref_key: "menu",
      ref: menu,
      id: "overlay_menu",
      model: filteredItems.value,
      popup: true
    }, null, 8, ["model"]),
    _createVNode(DeleteConfirmDialog, {
      "deleted-name": "организацию и все ее департаменты",
      visible: confirmVisibleDelete.value,
      blocked: blockedButtonDelete.value,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (confirmVisibleDelete.value = false)),
      onDelete: deleteOrganization
    }, null, 8, ["visible", "blocked"]),
    _createVNode(UserCustomHistoryDialog, {
      items: historyItems.value,
      visible: confirmVisibleHistory.value,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (confirmVisibleHistory.value = false))
    }, null, 8, ["items", "visible"])
  ], 64))
}
}

})